(() => {
  'use strict';
  const cfg = JSON.parse(document.getElementById('seat-live-config').textContent);
  const form = document.getElementById('seat-product-form');
  const status = document.getElementById('cart-message');
  const root = document.getElementById('MPTreePdp');
  const buttons = ['add-cart', 'buy-now', 'seat-sticky-add'].map(id => document.getElementById(id));
  const labels = buttons.map(button => button.textContent);
  const route = cfg.root.replace(/\/$/, '');
  let busy = false, uncertain = false;
  const selected = () => cfg.variants.find(variant => variant.seats === Number(root.querySelector('.pack.selected').dataset.qty));

  function message(text = '', error = false) {
    status.hidden = !text;
    status.textContent = text;
    status.setAttribute('role', error ? 'alert' : 'status');
  }
  function sync() {
    const variant = selected();
    form.querySelector('[name=id]').value = variant.id;
    document.getElementById('seat-quantity').value = 1;
    buttons.forEach((button, i) => {
      button.disabled = busy || !variant.available;
      if (!busy) {
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = uncertain ? 'Check cart' : variant.available ? labels[i] : 'Unavailable';
      }
    });
  }
  function reset() { busy = false; sync(); }
  root.addEventListener('seat:selectionchange', sync);
  sync();
  window.addEventListener('pageshow', reset);
  document.querySelectorAll('.seat-country-form select').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));

  // Use the same shared drawer as Christmas lights, including refresh, focus and line editing.
  const bag = [...document.querySelectorAll('header nav a')].find(link => link.pathname === route + '/cart');
  if (bag) {
    bag.setAttribute('role', 'button');
    bag.setAttribute('aria-haspopup', 'dialog');
    bag.addEventListener('click', event => {
      const drawer = document.querySelector('cart-drawer');
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !drawer?.open) return;
      event.preventDefault();
      drawer.open(bag);
    });
    bag.addEventListener('keydown', event => {
      if (event.code === 'Space') { event.preventDefault(); bag.click(); }
    });
  }

  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = selected();
    if (busy || !variant.available) return;
    const checkout = event.submitter?.id === 'buy-now';
    const active = buttons.includes(document.activeElement) ? document.activeElement : event.submitter || buttons[0];
    busy = true;
    sync();
    active.classList.add('is-loading');
    active.setAttribute('aria-busy', 'true');
    active.textContent = uncertain ? 'Checking cart…' : checkout ? 'Opening checkout…' : 'Adding…';
    message();
    if (uncertain) {
      try {
        const drawer = document.querySelector('cart-drawer');
        drawer.setActiveElement(active);
        await document.querySelector('mp-cart-panel').refresh();
        uncertain = false;
        reset();
        message('Please review your cart before adding again.');
      } catch { location.assign(route + '/cart'); }
      return;
    }

    // One paid bundle variant, quantity 1: retain the existing fulfillment and discount semantics.
    const qty = variant.seats;
    const properties = {
      'Seat set': qty + ' ' + (qty === 1 ? 'seat' : 'seats'),
      'Bundle contents': qty + ' × Heated Stadium Seat (Black · Heated)'
    };
    if (qty > 1) properties['Included gift'] = '1 FREE Mystery Gift per set';
    const body = { items: [{ id: variant.id, quantity: 1, properties }] };
    const drawer = !checkout && document.querySelector('cart-drawer');
    if (drawer?.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(section => section.id);
      body.sections_url = location.pathname;
      drawer.setActiveElement(active);
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    let definitive = false;
    try {
      const response = await fetch(route + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body), signal: controller.signal
      });
      definitive = response.status >= 400 && response.status < 500;
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This seat set could not be added. Please try again.');
      if (drawer?.renderContents && data.sections?.['cart-drawer']) {
        try { drawer.renderContents(data); reset(); return; }
        catch { location.assign(route + '/cart'); return; }
      }
      location.assign(route + (checkout ? '/checkout' : '/cart'));
    } catch (error) {
      uncertain = !definitive;
      reset();
      message(uncertain ? 'Please check your cart before trying again.' : error.message, true);
      if (uncertain) {
        const link = document.createElement('a');
        link.href = route + '/cart';
        link.textContent = ' View cart';
        status.append(link);
      }
    } finally { clearTimeout(timer); }
  });
})();
